export default __webpack_public_path__ + "static/homepage-6-pisa-0cfbc42fefde300b12c63fcfa173141c.png";